<template>
  <div class="relative flex flex-col overflow-hidden">
    <div class="py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 cursor-grab" v-dragscroll>
      <div class="inline-block min-w-full overflow-hidden align-middle rounded-t-lg">
        <table class="min-w-full">
          <thead>
            <tr>
              <th class="py-3 pl-4 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b bg-gray-50" v-if="$scopedSlots.icon">
                <slot></slot>
              </th>
              <th v-for="key in keys" :key="key.slug" class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b whitespace-nowrap bg-gray-50">
                {{ key.name }}
              </th>
              <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b bg-gray-50" v-if="$scopedSlots.actions">
                <slot></slot>
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr v-for="item in items" :key="item.id" class="hover:bg-gray-50">
              <td v-if="$scopedSlots.icon" class="pl-4 text-right border-b border-gray-100 whitespace-nowrap" :class="small ? 'py-2 text-sm' : 'py-4'">
                <slot name="icon" :item="item"></slot>
              </td>
              <td v-for="key in keys" :key="key.name" class="px-6 border-b border-gray-100 whitespace-nowrap" :class="[key.class, small ? 'py-2 text-sm' : 'py-4']">
                <template v-if="key.display && item[key.slug]">
                  <div v-html="key.display(item[key.slug])"></div>
                </template>
                <template v-else>
                  <div v-html="item[key.slug]"></div>
                </template>
              </td>
              <td v-if="$scopedSlots.actions" class="px-6 text-right border-b border-gray-100 whitespace-nowrap" :class="small ? 'py-2 text-sm' : 'py-4'">
                <slot name="actions" :item="item"></slot>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll'

export default {
  name: 'DataTable',

  directives: {
    dragscroll
  },

  props: {
    keys: {
      type: Array
    },

    items: {
      type: Array
    },

    small: {
      type: Boolean
    }
  }
}
</script>